import React from 'react';
import { FormProps } from 'util/Form';
import CountryFormItem from 'components/shared/AddressFormSection/CountryFormItem';

interface CountryQuestionFormItemProps extends FormProps {
  fieldName: string;
  addressFieldName: string;
}

const CountryQuestionFormItem: React.FunctionComponent<CountryQuestionFormItemProps> = ({
  fieldName,
  addressFieldName,
  required,
  disabled,
}) => {
  return (
    <CountryFormItem
      fieldName={fieldName}
      addressFieldName={addressFieldName}
      required={required}
      disabled={disabled}
      label=""
      generateControlName={false}
    />
  );
};
export default CountryQuestionFormItem;
